import React, { Component } from "react";
import ReglaNegocioTabla from "./ReglaNegocioTabla";
import { connect } from "react-redux";
import { getReglaNegocioList } from './ReglaNegocioAction'
import { withRouter } from 'react-router-dom';

class ReglaNegocioContainer extends Component {

    componentDidMount() {
        //console.log("ReglaNegocioContainer");
        this.props.dispatch(getReglaNegocioList());
    }

    render() {
        return (
            <div>
                <ReglaNegocioTabla />
            </div>
        );
    }
}

export default connect()(ReglaNegocioContainer);
